import { mapRncpRecord } from "./frameworkCreateMutation";
import { EntityTypes } from "../../EntityTypes";
import { ISkillBlockResource } from "../../skill-blocks";
import { ISkillDomainResource } from "../../skill-domains";
import { ISkillResource } from "../../skills";
import { createApiMutationHook, IApiMutationFunction } from "../../utils/api";
import { mapOrderedRelationAsIRIs, mapRelationalValue, RelationalValue } from "../../utils/filters";
import { IFramework, IFrameworkResource, IFrameworkRncpRecord } from "../types";

export type IFrameworkPatchMutationParameters = {
    framework: RelationalValue<IFrameworkResource>;
    data: {
        title?: string;
        shortIdentifier?: string;
        rncpId?: string | null;
        rncpRecord?: IFrameworkRncpRecord;
        skills?: RelationalValue<ISkillResource>[];
        skillDomains?: RelationalValue<ISkillDomainResource>[];
        skillBlocks?: RelationalValue<ISkillBlockResource>[];
    };
    locale?: string;
};

export type IFrameworkPatchMutationResult = IFramework;

export const frameworkPatchMutation: IApiMutationFunction<IFrameworkPatchMutationParameters> = ({
    framework,
    data: { title, shortIdentifier, rncpId, rncpRecord, skills, skillDomains, skillBlocks },
    locale,
}) => {
    return {
        method: "PATCH",
        url: `/frameworks/${mapRelationalValue(framework)}`,
        data: {
            title,
            shortIdentifier,
            rncpId,
            ...(rncpRecord !== undefined || rncpId === null ? mapRncpRecord(rncpRecord) : {}),
            skills: mapOrderedRelationAsIRIs(EntityTypes.SKILL, skills),
            skillDomains: mapOrderedRelationAsIRIs(EntityTypes.SKILL_DOMAIN, skillDomains),
            skillBlocks: mapOrderedRelationAsIRIs(EntityTypes.SKILL_BLOCK, skillBlocks),
        },
        headers: {
            "Content-Type": "application/merge-patch+json",
            ...(locale ? { "x-locale": locale } : {}),
        },
    };
};

export const useFrameworkPatchMutation = createApiMutationHook<
    IFrameworkPatchMutationParameters,
    IFrameworkPatchMutationResult
>(frameworkPatchMutation);
